<template>
  <div class="box margin-top-s">
    <div class="box-content custom-card">
      <div class="flex row middle">
        <span v-if="tooltip" class="info tooltip">
          <span class="tooltiptext">{{ tooltip }}</span>
        </span>
        <div v-if="icon" class="flex-1 middle big-icon">
          <div class="no-mobile">
            <i :class="`${icon}`"></i>
          </div>
        </div>
        <div class="flex-2">
          <span class="title flex center w100">{{ label }}</span>
          <h3 v-if="!money" class="flex center margin-top-s">
            {{ value | number }}<span v-if="suffix">{{ suffix }}</span>
          </h3>
          <h3 v-else class="flex center margin-top-s">
            {{ value | money(currency) }}<span v-if="suffix">{{ suffix }}</span>
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "box-info",
  props: ["label", "tooltip", "value", "money", "icon", "suffix", "currency"],
  components: {},
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.custom-card {
  min-width: 250px;
  position: relative;
  .big-icon {
    text-align: right;
    i {
      color: var(--primary);
      font-size: 30px;
      margin-right: 20px;
    }
  }
  .title {
    white-space: nowrap;
  }
  .info {
    position: absolute;
    right: 4px;
    top: 4px;
    font-size: 16px;
  }
  h3 {
    font-size: 22px;
    white-space: nowrap;
  }
  h1 {
    font-size: 48px;
    color: var(--secondary);
    text-shadow: 2px 1px #000;
  }

  .tooltiptext {
    left: -180px !important;
    top: 21px !important;
  }

  &.negative {
    h1 {
      color: #ff2727b5 !important;
    }
  }
}
</style>
